/** @format — fixed 36×36 touch target with centered icon/hover state */

export default function MobileIconButton({ children, className = "", ...props }) {
  return (
    <button
      type="button"
      className={`inline-flex items-center justify-center w-9 h-9 rounded-lg text-[#475367] hover:bg-gray-100 active:bg-gray-100 transition-colors flex-shrink-0 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
